import { UI } from '../UI';
import { App } from '../App';
import { Common } from '../Common';
import { Prelisting } from '../../pages/Prelisting';
import { ColorCarousel } from '../ColorCarousel';
import { SortFilter } from '../SortFilter';
import { User } from '../User';

export const copyStoreDialog = (function () {
  let $step = 0;
  let $stepCount = 2;

  let mapping = {
    details: (data) => {
      let details = [];
      data.forEach((obj) => {
        obj.details.forEach((det) => {
          det.checked = true;
          det.group = obj.groupName;
          details.push(det);
        });
      });
      return details;
    },
    filters: (data) => {
      return [
        {
          displayName: 'Artwork',
          filterTypeName: 'TextBox',
          internalName: 'Artwork',
          values: [{ name: data.artworkFrontTitle, value: data.artworkFrontTitle }]
        },
        {
          displayName: 'Blank',
          filterTypeName: 'TextBox',
          internalName: 'Blank',
          values: [{ name: data.blank.title, value: data.blank.title }]
        }
      ];
    }
  };

  let run = () => {
    $step++;
    if ($step == $stepCount) {
      return loadSecondStepData();
    }
    if ($step == 1) {
      return loadFirstStepData();
    }
    saveCopyStore();
  };

  let openStepStoreDialog = (data) => {
    let template = require('./tmpl/dialog/copy-store.hbs');
    bootbox
      .dialog({
        title: $lang.MasterProductData.CopyStoreData,
        message: template(data),
        size: 'xl',
        className: 'modal-scrolled-content modal-copyStore-page copy-store-dialog',
        onHide: closeDialog
      })
      .init(() => {
        UI.unblockPage();

        $('.js-action-nextstep').on('click', run);
      });
  };

  let loadFirstStepData = () => {
    UI.block('.modal-content');

    $.when(
      App.ajaxData(
        `MasterProductData/copyStore/${DT.mpd_currenteditedcontent.accountId}/${DT.mpd_currenteditedcontent.id}`,
        {}
      )
    )
      .done((res) => {
        let copyStore = {
          step: $step,
          storeDatas: mapping.details(res.createdObject)
        };
        App.pageData('copyStore', copyStore);

        res = {
          ...res,
          ...{ $lang: $lang }
        };
        openStepStoreDialog(res);
      })
      .always((error) => {
        UI.unblock('.modal-content');
        UI.unblock('#MasterProductDataForm');
      });
  };

  let loadSecondStepData = (query = '') => {
    UI.block('.modal-content');

    let content = App.pageData('mpd_currenteditedcontent') || false;
    if (!content) {
      return;
    }

    let prelistingPageFilters = SortFilter.getFilters('prelistings');
    if (prelistingPageFilters) {
      SortFilter.cache('prelistings', prelistingPageFilters);
    }
    SortFilter.setFilters('prelistings', mapping.filters(content));
    console.log('content', content);
    let params = { action: 'dialog', reload: true, excludeIds: [content.id] };
    Prelisting.init(params);

    App.pageData('copyStore.step', $step);
  };

  let saveCopyStore = () => {
    let selectPrelistingDialogIds = App.pageData('selectPrelistingDialogIds') || [];
    if (!selectPrelistingDialogIds.length) {
      return;
    }

    let request = {
      copyStoreDetails: App.pageData('copyStore.storeDatas').filter((det) => det.checked),
      Ids: selectPrelistingDialogIds
    };

    UI.block('#MasterProductDataForm');
    UI.block('.modal-content');
    let url = `MasterProductData/copyStore/`;
    $.when(App.ajaxData(url, request, 'POST'))
      .done((res) => {
        $('.modal-copyStore-page').modal('hide');
        closeDialog();

        UI.notify({
          text: $lang.alert.SuccessfullySaved,
          icon: 'fal fa-check-circle',
          type: 'success'
        });
      })
      .always((error) => {
        UI.unblock('#MasterProductDataForm');
      });
  };

  let closeDialog = () => {
    $step = 0;
    let prelistingPageFilters = SortFilter.fromCache('prelistings') || false;
    SortFilter.setFilters('prelistings', prelistingPageFilters);
    App.pageData('selectPrelistingDialogIds', 'clear');
  };

  return {
    run
  };
})();
